import { useState, useMemo, useRef, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Icon } from 'components';
import { useOnClickOutside } from 'hooks';
import { Input, List, SelectValue, IconButton } from '../Select/Select.style';
import { dateParser } from 'helpers';

const DateInput = ({ searched, selected, setSelected }) => {
  const { t, i18n } = useTranslation();
  const [expand, setExpand] = useState(false);
  const selectRef = useRef();
  useOnClickOutside(selectRef, () => setExpand(false));

  const handleSelect = (value) => {
    setSelected({ date: value });
    setExpand(false);
  };

  const options = useMemo(() => dateParser(t, i18n), [t, i18n]);

  useEffect(() => {
    const date = options.find(
      (option) => option.value === moment(searched).format('yyyy-MM-DD')
    );
    setSelected({
      date: date ? date : options[1],
    });
  }, [options, setSelected, searched]);

  const handleExpand = () => setExpand((prev) => !prev);

  return (
    <Input ref={selectRef}>
      <TextField
        autoComplete="off"
        fullWidth
        value={selected.string}
        variant="standard"
        onClick={handleExpand}
        id="Date"
        label={t('flightstatus.search.date')}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                expand={expand.toString()}
                aria-label="icon-button"
                edge="end"
              >
                <Icon name="arrow" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          htmlFor: 'Date',
        }}
      />
      {expand && (
        <List>
          {options &&
            options.map((el) => (
              <SelectValue key={el?.value} onClick={() => handleSelect(el)}>
                {el.string}
              </SelectValue>
            ))}
        </List>
      )}
    </Input>
  );
};

export default DateInput;
